$(function () {
  const url = window.location.href;
  if (url.includes('#cooking-instructions')) {
    const cookingInstructions = document.getElementById('cooking-instructions');
    if (cookingInstructions) {
      const detailsTag = cookingInstructions.querySelector('details');
      if (detailsTag) {
        detailsTag.setAttribute('open', 'open');
      }
    }
  }
});
